import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { Route, Routes, Navigate, useLocation, useSearchParams } from 'react-router-dom'
import { message, Divider, Table, Pagination, Row, Col, InputNumber, Radio, Button, Spin, Tabs, Tag, Space, Badge, Popover } from 'antd';
import API from '@api/api.js';
import styles from './index.module.scss'
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import UpdatePasswordModal from '@view/compoents/personalCenterModal/updatePasswordModal'
import PSAIModal from "@PSAIComponents/PSAIModal";
import QRCode from 'qrcode.react'
import Payment from '@view/compoents/Payment';
import dayjs from 'dayjs';
import JSZip from 'jszip';
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";
import DeliveryPayContent from './components/DeliveryPayContent'
import BillDetailView from './components/BillDetailView'
import PayRecordTable from './components/PayRecordTable'
import DeliveryBillTable from './components/DeliveryBillTable'
import {downloadPDF} from './downloadPDF'
const icon1 = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99992 14.6673C9.84085 14.6673 11.5075 13.9211 12.714 12.7147C13.9204 11.5083 14.6666 9.84158 14.6666 8.00065C14.6666 6.15972 13.9204 4.49305 12.714 3.2866C11.5075 2.08018 9.84085 1.33398 7.99992 1.33398C6.15899 1.33398 4.49232 2.08018 3.28587 3.2866C2.07945 4.49305 1.33325 6.15972 1.33325 8.00065C1.33325 9.84158 2.07945 11.5083 3.28587 12.7147C4.49232 13.9211 6.15899 14.6673 7.99992 14.6673Z" stroke="#4A4D5E" strokeWidth="0.8" strokeLinejoin="round"/>
        <path d="M8 9.54232V8.20898C9.10457 8.20898 10 7.31355 10 6.20898C10 5.10442 9.10457 4.20898 8 4.20898C6.89543 4.20898 6 5.10442 6 6.20898" stroke="#4A4D5E" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8.00008 12.5417C8.46031 12.5417 8.83341 12.1686 8.83341 11.7083C8.83341 11.2481 8.46031 10.875 8.00008 10.875C7.53985 10.875 7.16675 11.2481 7.16675 11.7083C7.16675 12.1686 7.53985 12.5417 8.00008 12.5417Z" fill="#4A4D5E"/>
    </svg>
)
function uniqueByField(arr, field) {
    const seen = new Set();
    return arr.filter(item => {
        const value = item[field];
        if (seen.has(value)) {
            return false;
        }
        seen.add(value);
        return true;
    });
}

const PersonalCenter = () => {
    const { globalUser } = useContext(AppContext);
    const [force, updateForce] = useState()
    // tabs切换
    const [searchParams, setSearchParams] = useSearchParams()
    const [activeKey, setActiveKey] = useState(() => {
        const tab = searchParams.get('tab')
        const validTabs = ['waitPay', 'confirm', 'all', 'payRecord']
        return validTabs.includes(tab) ? tab : 'waitPay'
    })
    // 修改密码
    const [pwdOpen, setPwdOpen] = useState(false)
    // 充值
    const handleDownload = useCallback(async (record) => {
        try {
            // 服务内容标签
            const res2 = await API.getDemandTags()
            if (res2.code != 0) throw new Error(res2.message)
            const demandTags = res2.data.map(item => ({
                value: item.id,
                label: item.name,
            }))
            // 结算单详情
            const res = await API.getBillDetail({id: record.id})
            if (res.code != 0) throw new Error(res.message)

            const _data = res.data
            const billId = record.billId // 结算单编号
            // const payAccountName = record.payAccountName // 结算单位
            const profileName = _data.profileName // 结算单位
            const createdTime = dayjs(_data.createdTime).format("YYYY/MM/DD") // 结算日期
            const billDetails = _data.billDetails || []
            const confirmIP = _data.metadata?.confirmIP || ""
            const confirmTime = _data.metadata?.confirmTime || ""

            if (res.data.billDetails.some(item => item.demandWaitPay && item.demandWaitPay.length > 0)) {                
                const data = []
                for (let obj of billDetails) {
                    const demandWaitPay = obj.demandWaitPay || [] // 服务内容
                    const demandList = demandWaitPay.map((item, index, array) => {
                        const deductAmount = item.price || item.demandItems.reduce((pre, curr) => pre + Number(curr.price), 0)
                        const waitPayCount = item.waitPayNum
                        const checkoutTotal = deductAmount * waitPayCount
                        const totalWaitPayCount = array.reduce((pre, curr) => pre + curr.waitPayNum, 0)
                        return {
                            groupKey: `${obj.merchantId}_${obj.deliveryVersion}`,
                            merchantName: obj.merchantName,
                            deliveredTime: obj.deliveredTime, // 交付日期 
                            deliveryVersion: obj.deliveryVersion, // 交付批次
                            totalWaitPayCount: totalWaitPayCount, // 总结算数量
                            guideAmount: obj.guideAmount || 0, // 指导价
                            totalCheckoutTotal: obj.amount, // 实付价
                            urgentNum: obj.urgentNum || 0, // 总加急数
                            demandItems: item.demandItems.map(item2 => ({
                                ...item2,
                                demandName: demandTags.find(tag => tag.value == item2.demandId)?.label || "综合服务",
                            })), // 服务内容（签约单价）
                            waitPayCount: item.waitPayNum, // 结算数量
                            deductAmount, // 图片单价
                            checkoutTotal, // 结算金额
                            remark: obj.remark, // 备注
                            rowSpan: index != 0 ? 0 : array.length
                        }
                    })
                    data.push(...demandList)
                }
                const doc = downloadPDF(data, billId, createdTime, profileName, confirmIP, confirmTime)
                // 保存文件
                doc.save(`结算单_${billId}.pdf`)
            } else {
                const data = billDetails?.map(item => ({
                    groupKey: `${item.merchantId}_${item.deliveryVersion}`,
                    merchantName: item.merchantName, // 客户名称
                    deliveredTime: item.deliveredTime ? dayjs(item.deliveredTime).format("YYYY/MM/DD") : "",
                    deliveryVersion: item.deliveryVersion,
                    deductAmount: item.eachCost,
                    waitPayCount: item.waitPayNum,
                    checkoutTotal: item.amount,
                    remark: item.remark,
                    totalWaitPayCount: item.waitPayNum,
                    guideAmount: item.guideAmount || 0, // 指导价
                    totalCheckoutTotal: item.amount,
                    urgentNum: item.urgentNum || 0, // 总加急数
                    demandItems: [{
                        demandId: -1,
                        demandName: "综合服务",
                        price: item.eachCost,
                    }]
                })) || []
                const doc = downloadPDF(data, billId, createdTime, profileName, confirmIP, confirmTime)
                // 保存文件
                doc.save(`结算单_${billId}.pdf`)
            }            
            message.success("结算单下载成功")
        } catch (err) {
            console.error(err)
            message.warning(err.message)
        }
    }, [])
    // 查看结算单
    const [viewOpen, setViewOpen] = useState(false)
    const [viewRecords, setViewRecords] = useState([])
    const [viewDemandTags, setViewDemandTags] = useState([])
    const handleView = useCallback(async (record) => {
        try {
            // 服务内容标签
            const res2 = await API.getDemandTags()
            if (res2.code != 0) throw new Error(res2.message)
            const demandTags = res2.data.map(item => ({
                value: item.id,
                label: item.name,
            }))
            // 结算单详情
            const res = await API.getBillDetail({id: record.id})
            if (res.code != 0) throw new Error(res.message)
            if (res.data.billDetails.some(item => item.demandWaitPay && item.demandWaitPay.length > 0)) {
                const data = res.data
                const deliverItems = data.billDetails
                const listMerged = []
                for (let dvObj of deliverItems) {
                    const demandWaitPay = dvObj.demandWaitPay || []
                    const demandList = demandWaitPay.map((item, index, array) => {
                        const deductAmount = item.price || item.demandItems.reduce((pre, curr) => pre + Number(curr.price), 0)
                        const waitPayCount = item.waitPayNum
                        const checkoutTotal = deductAmount * waitPayCount
                        const groupKey = `${dvObj.merchantName}_${dvObj.deliveryVersion}`
                        return {
                            groupKey,
                            merchantName: dvObj.merchantName, // 商户名称
                            deliveryVersion: dvObj.deliveryVersion, // 交付批次
                            projectType: null, // 项目类型
                            deliveredTime: dvObj.deliveredTime, // 交付日期
                            completedTime: dvObj.completedTime, // 完成日期
                            demandItems: item.demandItems, // 服务内容（签约单价）
                            deductAmount, // 图片单价
                            waitPayCount: item.waitPayNum, // 待结算数量
                            checkoutTotal, // 结算金额
                            totalWaitPayCount: dvObj.waitPayNum, // 总结算数量
                            guideAmount: dvObj.guideAmount || 0, // 指导价
                            totalCheckoutTotal: dvObj.amount, // 实付价
                            urgentNum: dvObj.urgentNum || 0, // 总加急数
                            remark: dvObj.remark, // 备注
                            rowSpan: index != 0 ? 0 : array.length,
                        }
                    })
                    listMerged.push(...demandList)
                }
                const listMergedSorted = listMerged.sort((a, b) => dayjs(a.deliveredTime).valueOf() - dayjs(b.deliveredTime).valueOf())
                const dataSourceMerged = listMergedSorted.map((item, index) => ({
                    ...item,
                    rowKey: index
                }))
                const dataSourceDisplay = dataSourceMerged
                setViewRecords(dataSourceDisplay)
            } else {
                const data = res.data
                const billDetails = data.billDetails?.map(item => ({
                    deliveredTime: item.deliveredTime ? dayjs(item.deliveredTime).format("YYYY/MM/DD") : "",
                    completedTime: item.completedTime ? dayjs(item.completedTime).format("YYYY/MM/DD") : "",
                    merchantName: item.merchantName, // 商户名称
                    deliveryVersion: item.deliveryVersion,
                    deductAmount: item.eachCost,
                    waitPayCount: item.waitPayNum,
                    checkoutTotal: item.amount,
                    remark: item.remark,
                    totalWaitPayCount: item.waitPayNum,
                    guideAmount: item.guideAmount || 0, // 指导价
                    totalCheckoutTotal: item.amount,
                    urgentNum: item.urgentNum || 0, // 加急数量
                    demandItems: [{
                        demandId: -1,
                        demandName: "综合服务",
                        price: item.eachCost,
                    }]
                })) || []
                setViewRecords(billDetails)
            }            
            setViewDemandTags(demandTags)
            setViewOpen(true)
        } catch (err) {
            console.error(err)
            message.warning(err.message)
        }
    }, [])
    // 结算支付
    const [deliveryPayOpen, setDeliveryPayOpen] = useState(false)
    const [deliveryPayRecord, setDeliveryPayRecord] = useState()
    const handlePay = useCallback((record) => {
        API.payForDeliveryBill({
            id: record.id,
            channel: "alipay",
            pay: false
        }).then(res => {
            console.log('payForDeliveryBill', res)
            if (res.code === 0) {
                const data = res.data
                if (data.needPay) { // 需要支付
                    setDeliveryPayOpen(true)
                    setDeliveryPayRecord({
                        id: record.id,
                        amount: record.amount,
                        channel: "alipay",
                        payInfo: data,
                    })
                } else { // 不需要支付，弹出二次确认
                    PSAIModal.confirm({
                        title: `将扣除账户余额￥${data.dealAmount}元`,
                        okText: '确定',
                        cancelText: '取消',
                        onOk () {
                            return API.payForDeliveryBill({
                                id: record.id,
                                channel: "alipay",
                                pay: true
                            }).then(res => {
                                if (res.code === 0) {
                                    message.success("支付成功")
                                    updateForce({})
                                } else {
                                    message.warning(res.message)
                                }                                
                            })
                        }
                    })
                }
                console.log('支付', res.data)
            } else {
                message.warning(res.message)
            }
        })
    }, [])
    // 确认结算
    const handleConfirm = useCallback((record) => {
        PSAIModal.confirm({
            title: `确定确认结算单吗？`,
            okText: '确定',
            cancelText: '取消',
            onOk () {
                return API.confirmBill({
                    billId: record.billId,
                }).then(res => {
                    if (res.code === 0) {
                        message.success("确认确认结算单成功")
                        updateForce({})
                    } else {
                        message.warning(res.message)
                    }                                
                })
            }
        })
    }, [])

    const [waitPayNum, setWaitPayNum] = useState(0)
    const [confirmNum, setConfirmNum] = useState(0)

    // tabitems
    const items = useMemo(() => [{
        key: "waitPay",
        label: (
            <Badge count={waitPayNum} color="#006EFF" offset={[15, 6]}>
                待支付
            </Badge>
        ),
        forceRender: true,
        children: (
            <DeliveryBillTable
                type="waitPay"
                actived={activeKey === "waitPay"}
                force={force}
                onPay={handlePay}
                onDownload={handleDownload}
                onView={handleView}
                onConfirm={handleConfirm}
                onTotal={setWaitPayNum}
            />
        )
    }, {
        key: "confirm",
        label: (
            <Badge count={confirmNum} color="#006EFF" offset={[15, 6]}>
                待确认结算单
            </Badge>
        ),
        forceRender: true,
        children: (
            <DeliveryBillTable
                type="confirm"
                actived={activeKey === "confirm"}
                force={force}
                onPay={handlePay}
                onDownload={handleDownload}
                onView={handleView}
                onConfirm={handleConfirm}
                onTotal={setConfirmNum}
            />
        )
    }, {
        key: "all",
        label: "结算记录",
        children: (
            <DeliveryBillTable
                type="all"
                actived={activeKey === "all"}
                force={force}
                onPay={handlePay}
                onDownload={handleDownload}
                onView={handleView}
                onConfirm={handleConfirm}
            />
        )
    }, {
        key: 'payRecord',
        label: '充值记录',
        children: <PayRecordTable activeKey={activeKey} force={force} />,
    }], [
        activeKey,
        force,
        waitPayNum, setWaitPayNum,
        confirmNum, setConfirmNum,
        handlePay,
        handleDownload,
        handleView,
        handleConfirm
    ])

    // 待结算金额和账户余额
    const [pendingSettlement, setpPendingSettlement] = useState(0)
    const [accountBalance, setAccountBalance] = useState(0)
    useEffect(() => {
        API.getPowerBalance().then(res => {
            if (res.code === 0) {
                setpPendingSettlement(res.data.toPay)
                setAccountBalance(res.data.balance)
            } else {
                message.warning(res.message)
            }
        })
    }, [force])

    return (
        <div className={styles.PersonalCenter}>
            <div className={styles.left}>
                <img className={styles.img1} src={require('@assets/images/icon_Avatar.png')} alt="" />
                <Divider style={{ margin: '40px 0' }} />
                <div className={styles.messag_box}>
                    <p className={styles.messag_box_p1}>{globalUser?.mobile ? '更换' : '绑定'}手机号</p>
                    <p className={styles.messag_box_p2}><span>{globalUser?.mobile?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}</span><span onClick={() => eventBus.emit('bindOrChangeMobile')}>{globalUser?.mobile ? '修改' : '绑定'}</span></p>
                </div>
                <div className={styles.messag_box}>
                    <p className={styles.messag_box_p1}>账号密码</p>
                    <p className={styles.messag_box_p2}><span style={{ fontWeight: 'bold' }}>******</span><span onClick={() => setPwdOpen(true)}>{localStorage.getItem('noPassword') == 'true' ? '设置' : '修改 '}</span></p>
                </div>
                <div className={styles.bottomBox}>
                    <img className={styles.img2} src={require('@assets/images/customCode.png')} alt="" />
                    <p>遇到问题? </p>
                    <p>请联系您的运营专员或者添加此微信</p>
                </div>
            </div>
            <div className={styles.right}>
                <p className={styles.title}>消费记录</p>
                <div className={styles.order_top}>
                    <span>
                        待结算金额
                        <Popover arrow={false} content="此金额仅包含需系统确认的结算金额">
                            {icon1}
                        </Popover>
                    </span>
                    <span>￥ {pendingSettlement}</span>
                    <span>账户余额</span>
                    <span>￥ {accountBalance}</span>
                </div>
                <Tabs
                    className={styles.tabs}
                    activeKey={activeKey}
                    items={items}
                    tabBarGutter={50}
                    onChange={key => {
                        setActiveKey(key)
                        setSearchParams({ tab: key }, { replace: true })
                    }}
                />
            </div>
            <PSAIModal
                title=""
                open={deliveryPayOpen}
                maskClosable={false}
                footer={null}
                maxWidth={500}
                onCancel={() => setDeliveryPayOpen(false)}
                getContainer={"body"}
            >
                <DeliveryPayContent
                    record={deliveryPayRecord}
                    onClose={() => {setDeliveryPayOpen(false);updateForce({})}}
                />
            </PSAIModal>
            <PSAIModal
                title=""
                open={viewOpen}
                maskClosable={false}
                footer={null}
                maxWidth={1600}
                onCancel={() => setViewOpen(false)}
                getContainer={"body"}
            >
                <BillDetailView
                    dataSource={viewRecords}
                    demandTags={viewDemandTags}
                />
            </PSAIModal>
            <UpdatePasswordModal open={pwdOpen} closeFunc={() => setPwdOpen(false)} />
        </div>
    )
}
export default PersonalCenter 